import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShortcutLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 1055.2 1030.2",
	style: { enableBackground: "new 0 0 1055.2 1030.2" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#58B1E4;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M823.2,373.2L823.2,373.2c0-81.6-66.2-147.8-147.8-147.8H379.8l0,0l0,0c-37.8,0-75.7,14.4-104.5,43.3l0,0 c-57.7,57.7-57.7,151.3,0,209l52.6,52.6c-56,21.1-95.9,75.1-95.9,138.5l0,0c0,81.6,66.2,147.8,147.8,147.8h295.6l0,0 c37.8,0,75.7-14.4,104.5-43.3l0,0c57.7-57.7,57.7-151.3,0-209l-52.6-52.6C783.3,490.7,823.2,436.6,823.2,373.2z M315.9,732.8 c-17.1-17.1-26.5-39.8-26.5-63.9s9.4-46.9,26.5-63.9c16.2-16.2,37.4-25.5,60.2-26.4l180.8,180.8H379.8 C355.6,759.2,333,749.9,315.9,732.8z M739.3,604.9c17.1,17.1,26.5,39.8,26.5,63.9c0,24.2-9.4,46.9-26.5,63.9 c-17.1,17.1-39.8,26.5-63.9,26.5c-24.2,0-46.9-9.4-63.9-26.5L315.9,437.2c-17.1-17.1-26.5-39.8-26.5-63.9s9.4-46.9,26.5-63.9 c17.1-17.1,39.8-26.5,63.9-26.5s46.9,9.4,63.9,26.5L739.3,604.9z M739.3,437.2c-16.2,16.2-37.4,25.5-60.2,26.4L498.4,282.8l0,0 h177.1c24.2,0,46.9,9.4,63.9,26.5c17.1,17.1,26.5,39.8,26.5,63.9S756.5,420.1,739.3,437.2z"
	}) })]
});
export { SvgShortcutLogo as ReactComponent };
